import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

const TestModeBanner = () => {
  const [testMode, setTestMode] = useState(false);

  useEffect(() => {
    const fetchMode = async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", "stripe_test_mode")
        .single();
      const val = data?.value as Record<string, unknown> | null;
      setTestMode(val?.enabled === true);
    };
    fetchMode();

    // Subscribe to changes
    const channel = supabase
      .channel("test-mode-banner")
      .on(
        "postgres_changes",
        { event: "UPDATE", schema: "public", table: "site_settings", filter: "key=eq.stripe_test_mode" },
        (payload) => {
          setTestMode((payload.new as any)?.value?.enabled === true);
        }
      )
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }, []);

  if (!testMode) return null;

  return (
    <div className="bg-amber-500 text-amber-950 text-center py-2 px-4 text-sm font-semibold flex items-center justify-center gap-2 z-[60] relative">
      <AlertTriangle className="h-4 w-4" />
      MODE TEST ACTIF — Les paiements sont fictifs (Carte 4242 4242 4242 4242)
    </div>
  );
};

export default TestModeBanner;
